export const applyEventCommands = (events, commands) => {
  return commands.reduce((currentEvents, command) => {
    if (command.insert) {
      return [...currentEvents, command.insert];
    }

    if (command.remove) {
      return currentEvents.filter(event => {
        if (event.id !== command.remove.id) return true;
        if (command.at && event.start !== command.at) return true;
        if (command.after && event.start < command.after) return true;
        return false;
      });
    }

    if (command.update) {
      return currentEvents.map(event => {
        if (
          event.id === command.update.id &&
          event.startForRecurrence === command.update.startForRecurrence
        )
          return command.update;
        return event;
      });
    }
    return currentEvents;
  }, events);
};

/**
 * A 4xx the server answers the same way however often an update is sent, such
 * as a 403 for a calendar that refuses the change (ARTFLT-1605). 408 and 429
 * can succeed on a later attempt; 412 is rethrown by retryUpdate on its own.
 */
export const isFinalClientError = err => {
  const status = Number(err && err.status);
  if (!(status >= 400 && status < 500)) return false;
  return status !== 408 && status !== 412 && status !== 429;
};

/**
 * Runs an event update, retrying it up to maxAttempts more times. A 412 (the
 * etag we sent is stale) and a final client error are thrown at once: sending
 * the same request again cannot succeed, and retrying only kept the save
 * spinning before the error showed.
 */
export const retryUpdate = async (callback, maxAttempts) => {
  if (!maxAttempts) return await callback();
  try {
    return await callback();
  } catch (err) {
    if (err && err.status == 412) throw err;
    if (isFinalClientError(err)) throw err;
    console.error('Remaining retries: ', maxAttempts, err);
    return retryUpdate(callback, maxAttempts - 1);
  }
};
